export default __webpack_public_path__ + "static/media/pic2.e21e1d77.jpg";